import * as React from 'react';

import { cn } from '@/lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, rows = 3, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          'min-h-[96px] w-full rounded-lg border border-border/70 bg-surface px-4 py-3 text-sm font-medium text-foreground shadow-input transition-all duration-200',
          'placeholder:font-normal placeholder:text-muted-foreground/80 focus-visible:outline-none focus-visible:border-primary focus-visible:ring-4 focus-visible:ring-primary/15 focus-visible:ring-offset-0 focus-visible:shadow-soft',
          'disabled:cursor-not-allowed disabled:opacity-60 resize-y',
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
